import React, {useEffect, useState} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import pushNotificationProviders from '@/services/pushNotification/pushNotificationProviders';
import pushNotificationService from '@/services/pushNotification/pushNotificationService';
import subscriptionService from '@/services/pushNotification/subscriptionService';

import styles from './Logs.module.css';

const SubscriptionInfo = () => {
    const [subscriptionInfo, setSubscriptionInfo] = useState(null);
    const [key, setKey] = useState(0);

    const storedSubscriptionInfo = subscriptionService.getStoredSubscriptionInfo();

    useEffect(() => {
        if (!storedSubscriptionInfo) return;
        const getSubscriptionInfo = async () => {
            const subscriptionInfo = await pushNotificationProviders.nativeProvider.getCurrentSubscription();

            setSubscriptionInfo(subscriptionInfo);
        };

        getSubscriptionInfo();
    }, [storedSubscriptionInfo]);

    const onInitPushNotificationClick = async () => {
        await pushNotificationService.requestSubscription();

        setKey(key + 1);
    };

    return (
        <div className='mt-4'>
            {storedSubscriptionInfo ? (
                <CopyToClipboard text={JSON.stringify(storedSubscriptionInfo)}>
                    <div className={styles.ClearLogsBtn}>Copy Firebase subscription info</div>
                </CopyToClipboard>
            ) : (
                <button onClick={onInitPushNotificationClick} className={styles.ClearLogsBtn}>
                    Init push notifications
                </button>
            )}
            {subscriptionInfo && (
                <CopyToClipboard text={JSON.stringify(subscriptionInfo)}>
                    <div className={styles.ClearLogsBtn}>Copy subscription info</div>
                </CopyToClipboard>
            )}
        </div>
    );
};

export default SubscriptionInfo;
